import React, { HTMLAttributes, useState } from 'react';
import styles from './styles';
import {Input} from 'antd';
import { FormattedMessage } from 'react-intl';

const getTextInput = (props: any) => {
  return (
    <Input {...props} type='text' style={{...styles.inputDefault, ...props.style}}>
    </Input>
  );
};

const getTextInputWithPlaceholder = (props: any) => {
  return (
    <FormattedMessage id={props.placeholder}>
      {(p: any) => <Input {...props} placeholder={p} type='text' style={{...styles.inputDefault, ...props.style}} />}
    </FormattedMessage>
  );
};

type outlinedTextInputProps = HTMLAttributes<HTMLInputElement> & {
  value: string;
  label: string;
  disabled?: boolean;
}
const GetOutlinedTextInput = (props: outlinedTextInputProps) => {
  const [focus, setFocus] = useState(false);

  const isOccupied = focus || (props.value && props.value.length > 0);
  let labelStyle: any = isOccupied ? {...styles.outlinedPlaceholder, ...styles.outlinedLabel } : {...styles.outlinedPlaceholder}
  if (isOccupied) {
    const bgColor = isOccupied && props.disabled ? styles.outlinedGradientLinear : styles.outlinedWhiteBg
    labelStyle = {...labelStyle, ...bgColor}
  }

  return (
    <div onFocus={() => setFocus(true)} onBlur={() => setFocus(false)} style={{position: 'relative'}}>
      <Input {...props} />
      <label style={labelStyle}>{props.label}</label>
    </div>
  );
}

export const RBHTextInput = (props: any) => {
  if (props.variant === 'outlined') {
    return GetOutlinedTextInput(props);
  }
  if (props.placeholder) {
    return getTextInputWithPlaceholder(props);
  }
  return getTextInput(props);
};

export default RBHTextInput;
